import {
  MelcoModelsUserListItem,
  UserManagementApi,
  useAPIQuery,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";
import { useTableErrorComponent } from "../table/useTableErrorComponent";
import { UsersListFiltersType } from "./UsersListFilterType";

export const useUsers = (allUsers?: boolean) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<MelcoModelsUserListItem, UsersListFiltersType>({
    // pageSizeOptions: [10, 20],
    // pageSize: 20,
  });

  //const baseApiConfig = useBaseAPIConfig();
  const query = useAPIQuery(
    UserManagementApi,
    ["users", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api) => {
      //const api = new UserManagementApi(baseApiConfig({ token }));
      console.log({ filters, currentPage, pageSize });
      let response;
      response = await api.userGetList({
        sortBy: sortBy(),
        firstName:
          filters?.firstName && !isEmpty(filters.firstName)
            ? filters.firstName
            : "",
        lastName:
          filters?.lastName && !isEmpty(filters.lastName)
            ? filters.lastName
            : "",
        userName:
          filters?.userName && !isEmpty(filters.userName)
            ? filters.userName
            : "",
        countryList:
          filters?.countryCode && !isEmpty(filters.countryCode)
            ? filters.countryCode.join(",")
            : undefined,

        searchText:
          filters?.searchText && !isEmpty(filters.searchText)
            ? filters.searchText
            : "",
        allUsers: allUsers === false ? false : true,
      });

      return response?.list ? response?.list : [];
    },
    {
      queryOptions: {
        keepPreviousData: false,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
